import { trackView } from '../../../_common/client/tracking';

export const trackReviewCountOnPageImpression = (rootElement: HTMLElement) => {
    const trackedReviewCount = rootElement.getAttribute('data-tracked-review-count');
    if (trackedReviewCount == null) return;
    trackView({ review_ReviewCount: [trackedReviewCount] });
};
